
export const initialState = (page) => ({
  entity: {
    id: 0,
    columns: [],
    title: ''
  },
  staticFilter: null,
  updating: false,
  page,
  order: 0
})
